import React from 'react';
import api from 'controllers/raymanAPI';
import Singletons from 'controllers/Singletons';

function map(item)
{
    return {...item, id: item.tagID}
}

async function getData()
{
    let indexed = {};
    let active = [];

    let response = await api.tags.getAll();
    let data = await response.json();
    data = data.map((item)=>map(item));
    data.forEach(item => {
        indexed[item.tagID] = item
        if(!item.disabled) active.push(item);
    });
    
    return {array: data, indexed: indexed, active: active};
}

const TagsCtx = React.createContext({
    loading: true, 
    data: {
        array: [], 
        indexed: {},
        active: []
    }, 
    funcs: {
        create: () => {},
        update: () => {},
        archive: () => {},
        restore: () => {},
        delete: () => {},
    }
});

function TagsCtxProvider(props)
{

    const [loading, setLoading] = React.useState(true);
    const [data, setData] = React.useState({array: [], indexed: [], active: []});

    React.useEffect(() => {
        getData().then(values => {
            setData(values);
            setLoading(false);
        });
    }, []);

    const internalUpdate = React.useCallback((tagID, tagData) => {
        let tmp = {...data};
        Object.keys(tagData).forEach((key) => {
            tmp.indexed[tagID][key] = tagData[key];
            if(key === "disabled")
            {
                let index = tmp.active.indexOf(tmp.indexed[tagID]);
                if(tagData[key] === true)
                {
                    if(index > -1) tmp.active.splice(index,1);
                }
                else
                {
                    if(index === -1) tmp.active.push(tmp.indexed[tagID]);
                }
            }
        })
        setData(tmp);
    }, [data]);

    const internalAdd = React.useCallback(async (tagID, item) => {
        if(data.indexed[tagID] !== undefined) return internalUpdate(tagID, item);

        let tmp = {...data};
        //let result = await api.tags.getSingle(tagID);
        //if(result.ok)
        {
            item = map(item);
            let index = tmp.array.push(item);
            tmp.indexed[item.id] = tmp.array[index-1];
            if(!item.disabled) tmp.active.push(item);

            setData(tmp);
        }
    }, [data, internalUpdate]);

    const internalDelete = React.useCallback((tagID) => {
        let tmp = {...data};
        let item = tmp.indexed[tagID];

        // remove from active
        let index = tmp.active.indexOf(item);
        if(index > -1) tmp.active.splice(index,1);

        // remove from array
        index = tmp.array.indexOf(item);
        if(index > -1) tmp.array.splice(index,1);

        delete tmp.indexed[tagID];

    }, [data]);


    const create = React.useCallback(async (data) => {
        let result = await api.tags.post(data);
        if(result.ok)
        {
            let tag = await result.json();
            internalAdd(tag.tagID, tag);
        }
    }, [internalAdd]);

    const update = React.useCallback(async (tagID, data) => {
        let result = await api.tags.updateSingle(tagID, data);
        if(result.ok) internalUpdate(tagID, data);

    }, [internalUpdate]);

    const archive = React.useCallback(async (tagID) => {
        let result = await api.tags.archive(tagID);
        if(result.ok) internalUpdate(tagID, {disabled: true});
    }, [internalUpdate]);

    const restore = React.useCallback(async (tagID) => {
        let result = await api.tags.restore(tagID);
        if(result.ok) internalUpdate(tagID, {disabled: false});
    }, [internalUpdate]);

    const remove = React.useCallback(async (tagID) => {
        let result = await api.tags.delete(tagID);
        if(result.ok) internalDelete(tagID);
    }, [internalDelete]);

    React.useEffect( function handleNotifications() {

        const handleCreate = (message) => internalAdd(message.tagID, message);
        const handleEnable = (message) => internalUpdate(message.tagID, {disabled: false});
        const handleDisable = (message) => internalUpdate(message.tagID, {disabled: true});
        const handleUpdate = (message) => internalUpdate(message.tagID, message);
        const handleDelete = (message) => internalDelete(message.tagID, message);

        Singletons.NotificationsSocket.on('tags.created', handleCreate);
        Singletons.NotificationsSocket.on('tags.disabled', handleDisable);
        Singletons.NotificationsSocket.on('tags.enabled', handleEnable);
        Singletons.NotificationsSocket.on('tags.updated', handleUpdate);
        Singletons.NotificationsSocket.on('tags.deleted', handleDelete);

        return () => {
            Singletons.NotificationsSocket.off('tags.created', handleCreate);
            Singletons.NotificationsSocket.off('tags.disabled', handleDisable);
            Singletons.NotificationsSocket.off('tags.enabled', handleEnable);
            Singletons.NotificationsSocket.off('tags.updated', handleUpdate);
            Singletons.NotificationsSocket.off('tags.deleted', handleDelete);
        }

    }, [internalAdd, internalUpdate, internalDelete]);

    return <TagsCtx.Provider value={{loading: loading, data: {...data}, funcs: {create: create, update: update, archive: archive, restore: restore, delete: remove}}} >
        {props.children}
        </TagsCtx.Provider>
}

export {TagsCtx, TagsCtxProvider};